<template>
  <div @contextmenu.prevent @click="antiScreenshotDisableClick">
    <div id="AntiPrint" class="hidden">
      <h1 class="text-black">
        Nope! - Printing, Recording, Screenshotting or Sharing Simulations Is Not Allowed<br /><br />Your Access Will Be Terminated If The
        TOS Is Broken<br /><br />Contact Intellectual Point For More Information<br /><br />
      </h1>
      <h1 class="text-black">{{ activeUserInfo.id }}</h1>
      <h1 class="text-black">{{ activeUserInfo.first_name }} {{ activeUserInfo.last_name }}</h1>
      <h1 class="text-black">{{ activeUserInfo.email }}</h1>
    </div>
    <div v-if="simulationData && simulationLegacyData" ref="cursor" class="vx-row simulation-page" id="LegacySimulationRenderer">
      <div class="vx-col lg:w-9/12 md:w-8/12 sm:w-5/5">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vx-card class="mb-3">
              <div class="flex justify-between items-center align-middle">
                <div class="flex items-center align-middle">
                  <img
                    :src="simulationData.thumbnail"
                    v-if="simulationData.thumbnail"
                    width="40"
                    height="40"
                    class="rounded shadow-md cursor-pointer block mr-3"
                    draggable="false"
                    alt=""
                  />
                  <vs-input v-if="enableEditMode" v-model="simulationData.name" class="ml-1" style="min-width: 14vw"></vs-input>
                  <h2 v-else class="font-bold ml-2">{{ simulationData.name }}</h2>
                </div>
                <div class="flex items-center align-middle">
                  <vs-button color="danger" icon-pack="feather" icon="icon-arrow-left" @click="$router.push('/simulations/select')"
                    >Exit To Simulation Selector
                  </vs-button>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <component
          :class="(!simulationPaused && simulationAntiSkid) || !simulationAntiSkid ? 'block' : 'hidden'"
          :is="dynamicComponent"
          :key="renderKey"
          ref="simulation"
          :data="{ simulation: simulationData, legacy: simulationLegacyData, options: simulationOptions }"
          v-on:enableMarkButton="enableMarkButton"
          v-on:simulation_full_correct="simulationFullCorrect"
          v-on:simulation_getting_there="simulationGettingThere"
          v-on:simulation_update_options="simulationUpdateOptions"
        />
        <div :class="(!simulationPaused && simulationAntiSkid) || !simulationAntiSkid ? 'hidden' : 'block'" class="paused-overlay">
          <div class="flex items-center justify-center">
            <img src="https://connect-cdn.intellectualpoint.com/assets/images/logos/Academy.png" width="400" alt="IP Logo" />
          </div>
          <h1 class="mt-10 font-bold text-center">You Are Currently Paused</h1>
          <h1 class="mt-4 font-light text-center">To Resume Tap In The Middle Of The Screen</h1>
        </div>
      </div>
      <div class="vx-col lg:w-3/12 md:w-4/12 sm:w-5/5">
        <vx-card class="mb-5">
          <div class="flex justify-between items-center">
            <div>
              <h2 class="mb-1">Simulation Progress</h2>
              <h5 class="font-bold mb-1">
                Score <span class="font-light">{{ simulationCurrentScore.correct }} / {{ simulationLegacyData.total_score }}</span>
              </h5>
              <h5 class="font-bold mb-1">Difficulty <span class="font-light">Normal</span></h5>
              <h5 class="font-bold mb-1">
                Completed <span class="font-light">{{ simulationProgressData.completed ? 'Yes' : 'No' }}</span>
              </h5>
            </div>
            <vs-input-number v-if="enableEditMode" min="0" v-model="simulationLegacyData.total_score" />
            <radial-progress-bar
              v-else
              :diameter="115"
              :completed-steps="simulationCurrentScore.correct"
              :total-steps="simulationLegacyData.total_score"
              :animateSpeed="1100"
              timingFunc="ease"
              innerStrokeColor="#0000006b"
              startColor="#0cdc62"
              stopColor="#0cdc62"
              :strokeWidth="7"
              :innerStrokeWidth="7"
            >
              <h2 class="font-light">{{ simulationCurrentScore.percent }}%</h2>
            </radial-progress-bar>
          </div>
        </vx-card>
        <vx-card class="mb-5" collapse-action title="Instructions">
          <div>
            <!-- simulation instructions -->
            <quill-editor v-if="enableEditMode" v-model="simulationData.instructions_content"></quill-editor>
            <div
              v-else
              class="mb-6 instructions-show-render"
              :class="(!simulationPaused && simulationAntiSkid) || !simulationAntiSkid ? 'block' : 'instructions-blur'"
              v-html="simulationData.instructions_content"
            />
            <vs-input
              v-if="enableEditMode"
              v-model="simulationData.explanation_video_id"
              class="w-full mt-10 mb-5"
              label-placeholder="Explanation Video ID"
            ></vs-input>
            <vs-button
              v-if="!enableEditMode && simulationData.explanation_video_id"
              class="mt-3 font-bold w-full"
              color="primary"
              icon="icon-film"
              icon-pack="feather"
              type="border"
              @click="toggleExplanationVideo"
            >
              {{ showExplanationVideo === false ? 'Watch the Simulation Video' : 'Hide the Simulation Video' }}
            </vs-button>
          </div>
        </vx-card>
        <vx-card class="mb-5 pt-0">
          <div v-if="!enableEditMode">
            <vs-button
              v-if="!simulationComplete"
              class="my-2 font-bold flex"
              color="warning"
              icon="icon-refresh-cw"
              icon-pack="feather"
              size="large"
              style="width: 100%; z-index: 1"
              type="filled"
              @click="resetSimulation"
              >Reset Simulation
            </vs-button>
            <vs-button
              v-if="!simulationComplete && simulationOptions.showMarkButton"
              id="markBtn"
              class="my-2 font-bold flex"
              color="success"
              icon="icon-check-circle"
              icon-pack="feather"
              size="large"
              style="width: 100%; z-index: 1"
              type="filled"
              @click="markSimulation"
              >Submit Simulation
            </vs-button>
            <div v-if="!simulationComplete && !simulationOptions.showMarkButton" class="flex align-middle mt-5">
              <vx-tooltip text="The Simulation Will Be Automatically Submitted Once All Steps Are Completed">
                <feather-icon icon="InfoIcon" svgClasses="h-6 w-6 text-white" class="mr-1" />
              </vx-tooltip>
              <p class="ml-1 self-center+">Auto Submission Is On</p>
            </div>
            <vs-button
              v-if="simulationComplete"
              class="my-2 font-bold flex"
              color="warning"
              icon="icon-refresh-cw"
              icon-pack="feather"
              size="large"
              style="width: 100%; z-index: 1"
              type="filled"
              @click="confirmResetSimulation"
              >Play Again
            </vs-button>
            <vs-button
              v-if="simulationComplete"
              class="my-2 font-bold flex"
              color="success"
              icon="icon-arrow-right-circle"
              icon-pack="feather"
              size="large"
              style="width: 100%; z-index: 1"
              type="filled"
              @click="confirmExitSimulation"
              >Next Simulation
            </vs-button>
          </div>
          <vs-button
            v-else
            class="w-full font-bold text-lg mb-6"
            icon="icon-edit"
            icon-pack="feather"
            type="filled"
            color="success"
            @click="updateFullSimulation"
            >Update Simulation
          </vs-button>
          <div v-if="$acl.check('proctor')" class="flex items-center justify-start align-middle mt-6">
            <p class="mr-2">Admin Mode</p>
            <vs-switch class="mr-2" v-model="enableEditMode" color="success"></vs-switch>
            <p class="ml-2 mr-2">Anti-Skid</p>
            <vs-switch v-model="simulationAntiSkid" color="success"></vs-switch>
          </div>
        </vx-card>
      </div>

      <movable-popup
        ref="videoPlayer"
        refVal="videoPlayerRef"
        title="Playing Video - Click Here to Drag Video Player"
        :active="showExplanationVideo"
        v-on:close="showExplanationVideo = false"
        padding="0"
      >
        <template v-slot:content>
          <div style="position: relative; padding-top: 56.25%">
            <iframe
              :src="'https://player.osidex.stream/vod/' + simulationData.explanation_video_id"
              style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              allowfullscreen="true"
            ></iframe>
          </div>
          <!-- <hls-player
            player_class="rounded-b"
            source="https://watch.videodelivery.net/14d2f6dc7a724f4317a8da5fc8fa9bc6"></hls-player> -->
        </template>
      </movable-popup>

      <!--- SIMULATION SUBMIT POPUP MESSAGE --->
      <vs-popup :active.sync="simulationSubmitPopup.active" class="pb-3" :title="simulationSubmitPopup.title">
        <div v-if="simulationSubmitPopup.type === 'warning'">
          <div class="flex justify-center mt-3 mb-5">
            <img src="https://cdn.discordapp.com/attachments/845520647710834708/845539048466284554/danger.png" width="150" alt="Check" />
          </div>
          <h1 class="text-center font-bold my-6" style="font-size: 42px">
            {{ simulationSubmitPopup.score }} / {{ simulationLegacyData.total_score }}
          </h1>
          <h3 class="text-center font-light mb-3">You're Getting There! Keep Practicing To Get 100%</h3>
          <div class="flex justify-center mt-3">
            <vs-button class="mt-5 mb-5" color="warning" @click="simulationSubmitPopup.active = false">Try Again</vs-button>
          </div>
        </div>
        <div v-if="simulationSubmitPopup.type === 'complete'">
          <div class="flex justify-center mt-3 mb-5">
            <img src="https://cdn.discordapp.com/attachments/845520647710834708/845539218570084372/payment.png" width="150" alt="Check" />
          </div>
          <h1 class="text-center font-bold my-6" style="font-size: 42px">
            {{ simulationSubmitPopup.score }} / {{ simulationLegacyData.total_score }}
          </h1>
          <h3 class="text-center font-light mb-3">Amazing Job! Simulation Complete</h3>
          <div class="flex justify-center mt-3">
            <vs-button class="mt-5 mb-5" color="success" @click="simulationSubmitPopup.active = false">Continue</vs-button>
          </div>
        </div>
      </vs-popup>

      <!--- USER DISPLAY INFO --->
      <div class="vx-col">
        <p class="mt-4" style="opacity: 85%">{{ activeUserInfo.first_name }} {{ activeUserInfo.last_name }} - {{ activeUserInfo.email }}</p>
      </div>
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>
</template>
<script>
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import MovablePopup from '../../../../../components/popup/MovablePopup'
import RadialProgressBar from 'vue-radial-progress'
import LottieAnimation from '../../../../../components/lottie/LottieAnimation'

export default {
  data () {
    return {
      componentFile: null,
      simulationData: null,
      simulationLegacyData: null,
      simulationProgressData: null,
      simulationProgressSummary: {
        score: 0,
        percent: 0
      },

      showGettingThereDialog: false,
      showSimulationFullCorrect: false,
      simulationComplete: false,
      disableMarkButton: false,

      simulationCurrentScore: {
        id: 1,
        name: 'Simulation Progress',
        color: 'success',
        percent: 0,
        total: 0,
        correct: 0
      },
      simulationSubmitPopup: {
        active: false,
        score: 0,
        title: 'Simulation Results',
        type: null
      },

      simulationOptions: {
        showMarkButton: true
      },

      renderKey: 0,
      currentAttempt: 0,

      isUserProctor: false,
      enableEditMode: false,
      editDescriptionCounter: 0,

      simulationPaused: false,
      simulationAntiSkid: true,
      keyDown: false,

      showExplanationVideo: false,

      loadedComponent: null
    }
  },
  computed: {
    dynamicComponent () {
      // eslint-disable-next-line
      return () => import(`./templates/${this.simulationLegacyData.content_file}.vue`);
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    antiPsEnable (e) {
      this.keyDown = false
      if (e.keyCode === 44) {
        this.$copyText(
          'Taking Screenshots Is Not Allowed, Your Access Will Be Revoked If You Continue To Record, Screenshot or Share Simulations',
        )
        e.preventDefault()
      }
    },
    antiScreenshotEnable (e) {
      this.keyDown = true
      if (e.keyCode === 123) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'E'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'C'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.keyCode === '91'.charCodeAt(0) && e.keyCode === 'S'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.keyCode === '93'.charCodeAt(0) && e.keyCode === 'S'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'S'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'H'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'A'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'F'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'E'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'C'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.keyCode === 91) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.keyCode === 92) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.keyCode === 93) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.ctrlKey && e.shiftKey) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.shiftKey && e.keyCode === 18) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 18) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.keyCode === 224 && e.shiftKey) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.keyCode === 17) {
        e.preventDefault()
      }
      if (e.keyCode === 18) {
        e.preventDefault()
      }
    },
    antiLeaveWindow () {
      this.simulationPaused = true
    },
    antiScreenshotDisableClick () {
      if (this.simulationPaused === true && this.keyDown === false) {
        this.simulationPaused = false
      }
    },
    confirmResetSimulation () {
      this.renderKey++
      this.leaveSimulation()
      this.playSimulation()
    },
    confirmExitSimulation () {
      this.$router.push('/simulations/select')
    },
    enableMarkButton () {
      this.$vs.loading.close('#markBtn> .con-vs-loading')
      this.disableMarkButton = false
    },
    exitSimulation () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Exit Simulation',
        text: 'Please confirm you want to exit the simulation. You will loose all of your progress.',
        accept: this.confirmExitSimulation,
        acceptText: 'Exit'
      })
    },
    fetchProgressData (body = {}) {
      this.$http
        .post(`app/simulations/${this.simulationData.id}/progress`, body)
        .then((response) => {
          this.simulationProgressData = response.data.data.progress
          this.simulationProgressSummary = response.data.data.summary
        })
        .catch(() => {})
    },
    getSimulationData (id) {
      this.$http
        .get(`app/simulations/${id}/starter`)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.simulationData = response.data.data.properties
            this.simulationLegacyData = response.data.data.legacy
            this.simulationProgressData = response.data.data.progress
            this.initSimulation()
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error While Loading Simulation',
            text: 'Please ensure you have the courses selected for the simulation you are trying to access',
            color: 'danger',
            position: 'top-right'
          })
          this.$router.push('/simulations/select')
        })
    },
    initSimulation () {
      this.componentFile = this.simulationLegacyData.content_file
    },
    leaveSimulation () {
      this.simulationComplete = false
      this.disableMarkButton = false
      this.currentAttempt = 0
    },
    markSimulation () {
      if (this.disableMarkButton === true) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Submission Cooldown',
          text: 'Please wait before re-marking your simulation',
          position: 'top-right'
        })
      }
      //Disable BTN
      this.disableMarkButton = true

      this.$vs.loading({
        background: '#187743',
        color: 'white',
        container: '#markBtn',
        scale: 0.45
      })

      //Send to Sim Template to Mark
      this.$refs.simulation.markSimulation()
    },
    playSimulation () {
      this.getSimulationData(this.$route.params.simulationId)
    },
    resetSimulation () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Reset Simulation',
        text: 'Please confirm you want to reset the simulation. You will loose all of your progress.',
        accept: this.confirmResetSimulation,
        acceptText: 'Reset'
      })
    },
    simulationFullCorrect (score) {
      this.fetchProgressData({ score })
      this.$confetti.start({})

      setTimeout(() => {
        this.$vs.loading.close('#markBtn> .con-vs-loading')
        this.simulationComplete = true
      }, 1)

      this.simulationCurrentScore.percent = Math.round((score / this.simulationLegacyData.total_score) * 100)
      this.simulationCurrentScore.correct = score

      setTimeout(() => {
        this.$confetti.stop()
      }, 3000)

      this.simulationFullCorrectSound.play()

      this.simulationSubmitPopup = {
        active: true,
        score,
        title: 'Amazing Job - Simulation Complete',
        type: 'complete'
      }
    },
    simulationGettingThere (score, dialog = true) {
      this.fetchProgressData({ score })

      setTimeout(() => {
        this.$vs.loading.close('#markBtn> .con-vs-loading')
        this.disableMarkButton = false
      }, 5000)

      this.simulationCurrentScore.percent = Math.round((score / this.simulationLegacyData.total_score) * 100)
      this.simulationCurrentScore.correct = score

      this.simulationGettingThereSound.play()
      this.currentAttempt++

      if (dialog) {
        this.simulationSubmitPopup = {
          active: true,
          score,
          title: 'You\'re Getting There - Try Again',
          type: 'warning'
        }
      }
    },
    simulationUpdateOptions (data) {
      this.simulationOptions = data
    },
    toggleExplanationVideo () {
      if (this.showExplanationVideo === false) {
        this.showExplanationVideo = true
      } else {
        this.$refs.videoPlayer.close()
      }
    },
    updateFullSimulation () {
      this.$vs.loading()
      this.updateSimulationProperties()
      this.updateSimulationLegacy()

      this.$vs.notify({
        title: 'Updated Simulation Successfully',
        text: `Simulation ${this.simulationData.name} has been updated.`,
        color: 'success',
        position: 'top-right'
      })
    },
    updateSimulationLegacy () {
      const pl = this.simulationLegacyData

      this.$http
        .post(`simulations/legacy/${this.simulationData.id}`, pl)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch((exception) => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating simulation properties'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update simulation properties',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    updateSimulationProperties () {
      const pl = this.simulationData
      pl.status = this.simulationData.status === undefined ? 'active' : this.simulationData.status
      pl.difficulty = parseInt(this.simulationData.difficulty.id)

      if (pl.name === undefined) {
        return this.$vs.notify({
          title: 'Failed to update simulation',
          text: 'Please provide a Simulation Name',
          color: 'danger',
          position: 'top-right'
        })
      }
      this.$http
        .post(`simulations/${this.simulationData.id}`, pl)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch((exception) => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating this simulation'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update simulation',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  mounted () {
    this.simulationTabError = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Notification.mp3')
    this.simulationFullCorrectSound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Success.mp3')
    this.simulationGettingThereSound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Error_Notification.mp3')

    window.simulationGettingThereSound = this.simulationGettingThereSound
    window.simulationFullCorrectSound = this.simulationFullCorrectSound
    window.simulationTabError = this.simulationTabError

    this.wasSidebarOpen = this.$store.state.reduceButton
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)

    this.playSimulation()

    window.addEventListener('blur', this.antiLeaveWindow)

    if (this.$acl.check('proctor')) {
      this.simulationAntiSkid = false
      this.isUserProctor = true
      return
    }

    window.addEventListener('keydown', this.antiScreenshotEnable)
    window.addEventListener('keyup', this.antiPsEnable)
  },
  beforeDestroy () {
    this.leaveSimulation()

    this.simulationData = null
    this.simulationLegacyData = null
    this.componentFile = null

    window.removeEventListener('keydown', this.antiScreenshotEnable)
    window.removeEventListener('keyup', this.antiPsEnable)
    window.removeEventListener('blur', this.antiLeaveWindow)

    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
  },
  watch: {
    enableEditMode () {
      this.getSimulationData(this.simulationData.id)
    }
  },
  components: {
    quillEditor,
    MovablePopup,
    RadialProgressBar,
    LottieAnimation
  }
}
</script>

<style lang="scss">
//Add Dynamic Importing

@import 'css/Renderer';

.ql-container {
  font-family: 'Poppins', Helvetica, Arial, sans-serif;
  font-size: inherit !important;
}

.ql-snow .ql-editor {
  h1 {
    font-size: 2em !important;
  }
  h2 {
    font-size: 1.5em !important;
  }
  h3 {
    font-size: 1.17em !important;
  }
  h5 {
    font-size: 0.83em !important;
  }
  h6 {
    font-size: 0.67em !important;
  }
}
</style>
